import { theme } from '@breakroom-nx/assets';
import { Tooltip, Badge, IconButton as IButton, View } from 'native-base';
import { FlexStyle } from 'react-native';

export interface IconButtonProps {
  icon: any;
  badgeNumber?: number | string;
  tooltipText?: string;
  position?: FlexStyle['position'];
  onPress?: any;
  disabled?: boolean;
}

export const IconButton = ({
  icon,
  onPress = undefined,
  badgeNumber = 0,
  tooltipText = undefined,
  disabled = false,
  position = undefined,
}: IconButtonProps) => {
  return (
    <View
      opacity={disabled ? 0.4 : 1}
      style={{
        position: position,
        zIndex: 999,
      }}
    >
      {badgeNumber !== 0 ? (
        <Badge
          bg={theme.colors.red[200]}
          colorScheme="danger"
          rounded="full"
          mt={-1}
          mr={-3}
          zIndex={9999}
          variant="solid"
          position={'absolute'}
          alignSelf="flex-end"
          _text={{
            fontSize: 12,
          }}
        >
          {badgeNumber}
        </Badge>
      ) : null}
      <Tooltip
        label={tooltipText ?? ''}
        isDisabled={tooltipText === undefined}
        openDelay={300}
        bg={theme.colors.surface[300]}
        borderColor={theme.colors.surface[500]}
        _text={{
          color: theme.colors.surface[600],
        }}
      >
        <IButton
          onPress={onPress}
          bg={'rgba(255, 255, 255, 0.07)'}
          rounded={'full'}
          icon={icon}
          opacity={0.5}
          _hover={{
            opacity: 1,
          }}
          _pressed={{
            backgroundColor: 'rgba(255, 255, 255, 0.07)',
            opacity: 0.7,
          }}
          disabled={disabled}
        />
      </Tooltip>
    </View>
  );
};
